import axios, { AxiosResponse } from 'axios';

const apiRootUrl = '/'

const api = axios.create({
  baseURL: apiRootUrl
});

export async function GetFile<T>(filepath: string): Promise<AxiosResponse<T>> {
  return api.get<T>(`${filepath}`);
}